class ProductAddons extends HTMLElement {
  constructor() {
    super();
    this.cards = this.querySelectorAll('.addon-card');
    this.summaryEl = this.querySelector('.product-addons__summary');
    this.addBtn = this.querySelector('.product-addons__add-btn');
    this.bindEvents();
  }

  bindEvents() {
    this.cards.forEach((card) => {
      const checkbox = card.querySelector('.addon-card__checkbox');
      if (checkbox) {
        checkbox.addEventListener('click', () => this.toggleCard(card));
      }

      card.querySelector('.addon-card__media')?.addEventListener('click', () => this.toggleCard(card));

      const swatches = card.querySelectorAll('.addon-card__swatch');
      swatches.forEach((swatch) => {
        swatch.addEventListener('click', () => this.selectVariantSwatch(card, swatch));
      });

      const variantSelect = card.querySelector('.addon-card__variant-select');
      if (variantSelect) {
        variantSelect.addEventListener('change', () => this.selectVariantDropdown(card, variantSelect));
      }

      const minusBtn = card.querySelector('.addon-card__qty-btn--minus');
      const plusBtn = card.querySelector('.addon-card__qty-btn--plus');
      const qtyInput = card.querySelector('.addon-card__qty-input');

      if (minusBtn) {
        minusBtn.addEventListener('click', () => {
          const current = parseInt(qtyInput.value) || 1;
          if (current > 1) qtyInput.value = current - 1;
          this.updateSummary();
        });
      }
      if (plusBtn) {
        plusBtn.addEventListener('click', () => {
          const current = parseInt(qtyInput.value) || 1;
          qtyInput.value = current + 1;
          this.updateSummary();
        });
      }
      if (qtyInput) {
        qtyInput.addEventListener('change', () => {
          if (parseInt(qtyInput.value) < 1) qtyInput.value = 1;
          this.updateSummary();
        });
      }
    });

    if (this.addBtn) {
      this.addBtn.addEventListener('click', () => this.addToCart());
    }
  }

  toggleCard(card) {
    card.classList.toggle('addon-card--selected');
    this.updateSummary();
  }

  selectVariantSwatch(card, swatch) {
    card.querySelectorAll('.addon-card__swatch').forEach((s) => s.classList.remove('addon-card__swatch--active'));
    swatch.classList.add('addon-card__swatch--active');

    const variantId = swatch.dataset.variantId;
    const price = swatch.dataset.variantPrice;
    const available = swatch.dataset.variantAvailable === 'true';
    const image = swatch.dataset.variantImage;

    card.dataset.selectedVariant = variantId;
    card.dataset.selectedPrice = price;

    const priceEl = card.querySelector('.addon-card__price-value');
    if (priceEl && price) {
      priceEl.textContent = this.formatMoney(parseInt(price));
    }

    if (image) {
      const imgEl = card.querySelector('.addon-card__media img');
      if (imgEl) imgEl.src = image;
    }

    const unavailableEl = card.querySelector('.addon-card__unavailable');
    const optionsEl = card.querySelector('.addon-card__quantity');
    if (!available) {
      if (unavailableEl) unavailableEl.style.display = 'block';
      if (optionsEl) optionsEl.style.display = 'none';
    } else {
      if (unavailableEl) unavailableEl.style.display = 'none';
      if (optionsEl) optionsEl.style.display = 'flex';
    }

    this.updateSummary();
  }

  selectVariantDropdown(card, select) {
    const option = select.options[select.selectedIndex];
    const variantId = option.value;
    const price = option.dataset.price;
    const available = option.dataset.available === 'true';
    const image = option.dataset.image;

    card.dataset.selectedVariant = variantId;
    card.dataset.selectedPrice = price;

    const priceEl = card.querySelector('.addon-card__price-value');
    if (priceEl && price) {
      priceEl.textContent = this.formatMoney(parseInt(price));
    }

    if (image) {
      const imgEl = card.querySelector('.addon-card__media img');
      if (imgEl) imgEl.src = image;
    }

    const unavailableEl = card.querySelector('.addon-card__unavailable');
    const qtyEl = card.querySelector('.addon-card__quantity');
    if (!available) {
      if (unavailableEl) unavailableEl.style.display = 'block';
      if (qtyEl) qtyEl.style.display = 'none';
    } else {
      if (unavailableEl) unavailableEl.style.display = 'none';
      if (qtyEl) qtyEl.style.display = 'flex';
    }

    this.updateSummary();
  }

  getSelectedAddons() {
    const selected = [];
    this.querySelectorAll('.addon-card--selected').forEach((card) => {
      const variantId = card.dataset.selectedVariant;
      const price = parseInt(card.dataset.selectedPrice) || 0;
      const qty = parseInt(card.querySelector('.addon-card__qty-input')?.value) || 1;
      const title = card.querySelector('.addon-card__title')?.textContent?.trim();
      const available = card.querySelector('.addon-card__unavailable')?.style.display !== 'block';

      if (variantId && available) {
        selected.push({ variantId, price, qty, title });
      }
    });
    return selected;
  }

  updateSummary() {
    if (!this.summaryEl) return;
    const addons = this.getSelectedAddons();
    const itemsList = this.summaryEl.querySelector('.product-addons__summary-items');
    const totalEl = this.summaryEl.querySelector('.product-addons__summary-total span:last-child');

    if (addons.length === 0) {
      this.summaryEl.style.display = 'none';
      return;
    }

    this.summaryEl.style.display = 'block';
    itemsList.innerHTML = '';
    let total = 0;

    addons.forEach((addon) => {
      const lineTotal = addon.price * addon.qty;
      total += lineTotal;
      const li = document.createElement('li');
      li.innerHTML = `<span>${addon.title} × ${addon.qty}</span><span>${this.formatMoney(lineTotal)}</span>`;
      itemsList.appendChild(li);
    });

    if (totalEl) totalEl.textContent = this.formatMoney(total);
  }

  formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return (window.Shopify?.currency?.active || '$') === '$'
      ? `$${amount}`
      : `${amount} ${window.Shopify?.currency?.active || ''}`;
  }

  async addToCart() {
    const addons = this.getSelectedAddons();
    if (addons.length === 0) return;

    this.addBtn.classList.add('loading');
    this.addBtn.disabled = true;

    const items = addons.map((a) => ({
      id: parseInt(a.variantId),
      quantity: a.qty,
    }));

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!res.ok) throw new Error('Add to cart failed');

      document.querySelectorAll('cart-notification, cart-drawer')?.forEach((el) => {
        if (typeof el.renderContents === 'function') {
          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => {
              el.renderContents(cart);
            });
        }
      });

      const cartCountEls = document.querySelectorAll('.cart-count-bubble span');
      if (cartCountEls.length > 0) {
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            cartCountEls.forEach((el) => (el.textContent = cart.item_count));
          });
      }

      this.addBtn.querySelector('.button-text').textContent = 'Added!';
      setTimeout(() => {
        this.addBtn.querySelector('.button-text').textContent =
          this.addBtn.dataset.defaultText || 'Add selected to cart';
      }, 2000);
    } catch (e) {
      console.error(e);
      this.addBtn.querySelector('.button-text').textContent = 'Error - try again';
      setTimeout(() => {
        this.addBtn.querySelector('.button-text').textContent =
          this.addBtn.dataset.defaultText || 'Add selected to cart';
      }, 2000);
    } finally {
      this.addBtn.classList.remove('loading');
      this.addBtn.disabled = false;
    }
  }
}

customElements.define('product-addons', ProductAddons);
